export const sleep = (delay: number) => new Promise<void>(resolve => setTimeout(resolve, delay));

export const waitBeforeComplete = async (
  startTime: number,
  waitTime: number,
  callback: () => void
): Promise<void> => {
  const executionTime = Date.now() - startTime;
  if (executionTime < waitTime) {
    await sleep(waitTime - executionTime);
  }
  callback();
};
